import { Box, Stack, Typography } from '@mui/material';
import { PAGE_WIDTH, TextLink } from './Section';
import { FOOTER } from './copy';

export function Footer() {
  return (
    <Box component="footer" sx={{ px: { xs: 3, md: 6 } }}>
      <Box
        sx={{
          maxWidth: PAGE_WIDTH,
          mx: 'auto',
          borderTop: '1px solid var(--rule)',
          py: { xs: 4, md: 6 },
        }}
      >
        <Box
          sx={{
            display: 'flex',
            flexDirection: { xs: 'column', sm: 'row' },
            justifyContent: 'space-between',
            alignItems: { xs: 'flex-start', sm: 'flex-start' },
            gap: 4,
          }}
        >
          <Box>
            <Box
              component="img"
              src={FOOTER.wordmarkSrc}
              alt={FOOTER.wordmarkAlt}
              sx={{
                height: 20,
                width: 'auto',
                display: 'block',
                '[data-theme="dark"] &': { filter: 'invert(1) hue-rotate(180deg)' },
              }}
            />
            <Typography variant="body2" sx={{ mt: 1.5, color: 'var(--ink-muted)', maxWidth: '60ch' }}>
              {FOOTER.tagline}
            </Typography>
          </Box>

          <Stack direction="row" spacing={3} component="nav" aria-label="Footer">
            {FOOTER.links.map((link) => (
              <TextLink key={link.label} to={link.to} sx={{ fontSize: '0.875rem' }}>
                {link.label}
              </TextLink>
            ))}
          </Stack>
        </Box>

        <Typography variant="body2" sx={{ mt: { xs: 4, md: 6 }, color: 'var(--ink-muted)' }}>
          {FOOTER.copyright}
        </Typography>
      </Box>
    </Box>
  );
}
